import { sanitizeUrl } from '@payments-frontend/utils';
/**
 * Opens the link in the current tab.
 */
export const openLink = (url: string) => {
    let sanitizedUrl = sanitizeUrl(url);

    window.location.assign(sanitizedUrl);
};
